export const SET_FAVOURITE_CONVERSATIONS = 'SET_FAVOURITE_CONVERSATIONS';
export const CLEAR_FAVOURITE_CONVERSATIONS = 'CLEAR_FAVOURITE_CONVERSATIONS';
